export default "__VITE_ASSET__jEBbJDxP__"